import React from "react";

function Loader(props) {
  const title = props.title || "rotating bars anim";
  const css = ".nc-loop-bars-rotate-48-icon-f{--animation-duration:0.8s;transform-origin:24px 24px;animation:nc-loop-bars-rotate-anim var(--animation-duration) infinite steps(8,start)}@keyframes nc-loop-bars-rotate-anim{0%{transform:rotate(0)}100%{transform:rotate(360deg)}}";

  return (
    <div className="app-loader-cntr " data-testid="loader">
      <svg height="48" width="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
        <title>{title}</title>
        <g fill="#2927B2">
          <g className="nc-loop-bars-rotate-48-icon-f">
            <path d="M37 22h10v4H37z" fill="#2927B2"/>
            <path d="M31.728 9.272h10v4h-10z" fill="#2927B2" opacity=".8" transform="rotate(-45 36.728 11.272)"/>
            <path d="M22 1h4v10h-4z" fill="#2927B21" opacity=".6"/>
            <path d="M9.272 6.272h4v10h-4z" fill="#2927B2" opacity=".4" transform="rotate(-45 11.272 11.272)"/>
            <path d="M1 22h10v4H1z" fill="#2927B2" opacity=".4"/>
            <path d="M6.272 34.728h10v4h-10z" fill="#2927B2" opacity=".4" transform="rotate(-45 11.272 36.728)"/>
            <path d="M22 37h4v10h-4z" fill="#2927B2" opacity=".4"/>
            <path d="M34.728 31.728h4v10h-4z" fill="#2927B2" opacity=".4" transform="rotate(-45 36.728 36.728)"/>
          </g>
          <style>{css}</style>
        </g>
      </svg>
    </div>
  );
}

export default Loader;
